import { render, staticRenderFns } from "./DeleteTargetingDialog.vue?vue&type=template&id=06d0780c&scoped=true"
import script from "./DeleteTargetingDialog.vue?vue&type=script&lang=js"
export * from "./DeleteTargetingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d0780c",
  null
  
)

export default component.exports